import React from 'react';

const Crown = ({color = '#1976d2', width = 20, height = 20}) => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width={width} height={height}
             viewBox="0 0 1024.000000 1024.000000">
            <g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
                <path d="M3853 8920 c-91 -24 -159 -58 -251 -126 -123 -93 -208 -221 -257
-389 l-26 -90 -2 -3225 -2 -3225 23 -78 c61 -213 187 -376 361 -466 160 -83
22 -76 1596 -76 1569 0 1430 -6 1595 73 59 28 95 56 171 131 84 83 103 109
142 191 91 187 82 -184 80 3460 -2 3169 -3 3226 -22 3301 -51 198 -188 369
-369 459 -105 52 -199 72 -350 73 -149 2 -142 5 -167 -79 -22 -71 -67 -138
-116 -171 -36 -24 -54 -28 -148 -33 -58 -4 -468 -5 -910 -4 -798 3 -803 3
-845 24 -80 42 -129 107 -142 188 -12 75 -27 82 -167 81 -84 0 -144 -7 -194
-19z m1590 -728 c67 -30 150 -112 178 -175 47 -110 17 -258 -73 -353 -106
-113 -269 -132 -421 -51 -113 60 -171 158 -169 286 1 73 11 103 58 177 37 58
73 87 153 121 47 20 69 23 141 20 59 -2 100 -10 133 -25z m-816 -14 c18 -18
33 -38 33 -45 0 -26 -53 -93 -78 -100 -26 -6 -46 11 -77 69 -15 27 -14 29 21
68 20 22 43 40 52 40 9 0 31 -14 49 -32z m1464 0 c48 -39 50 -64 7 -105 -51
-49 -77 -48 -113 4 -33 49 -32 69 6 104 39 37 51 36 100 -3z m-1928 -200 c60
-124 112 -181 204 -226 40 -19 73 -37 73 -41 0 -3 -34 -23 -75 -45 -94 -48
-162 -121 -214 -230 l-38 -78 -17 52 c-9 29 -28 69 -41 90 -36 57 -133 139
-203 172 -36 16 -62 34 -60 41 2 7 36 28 76 47 101 49 145 96 201 212 25 54
47 98 48 98 0 0 21 -42 46 -92z m2376 2 c58 -121 113 -180 207 -225 41 -19 74
-39 74 -45 0 -5 -36 -28 -80 -51 -117 -61 -177 -131 -232 -269 l-10 -25 -13
32 c-47 111 -157 230 -252 273 -35 16 -63 35 -63 42 0 8 32 30 71 49 91 43
153 111 205 224 21 46 41 84 44 85 3 0 25 -41 49 -90z m-1231 -546 c8 -2 12
-23 12 -59 l0 -55 -90 0 -90 0 0 64 0 64 78 -5 c42 -2 83 -6 90 -9z m166 -46
c-4 -35 -8 -65 -10 -67 -1 -2 -30 0 -63 4 -45 5 -61 11 -61 22 0 13 2 13 17 2
13 -11 12 -5 -5 25 -32 54 -24 64 50 69 35 2 67 4 71 5 4 1 5 -26 1 -60z
m-536 -114 c2 -27 1 -95 -3 -151 l-7 -102 -51 -17 c-29 -9 -102 -40 -164 -69
-295 -139 -518 -336 -702 -620 -101 -154 -182 -360 -232 -585 -21 -92 -24
-131 -23 -320 0 -197 2 -225 27 -332 81 -354 249 -630 539 -887 101 -90 305
-224 408 -268 l60 -26 0 -64 c0 -34 -2 -63 -4 -63 -2 0 -23 7 -46 15 -58 20
-62 12 -6 -9 25 -10 46 -24 48 -33 7 -33 -4 -173 -13 -173 -25 0 -224 93 -316
148 -391 232 -700 610 -868 1062 -200 537 -126 1206 186 1686 226 346 467 567
812 741 74 37 324 124 342 119 6 -1 12 -25 13 -52z m877 9 c235 -75 461 -211
677 -405 290 -263 498 -620 603 -1038 79 -313 61 -704 -46 -1033 -137 -419
-532 -894 -918 -1104 -61 -33 -291 -134 -305 -133 -1 0 -1 60 -2 133 0 72 -3
151 -7 173 l-7 42 52 17 c295 96 655 433 823 770 59 117 105 251 138 399 28
129 31 156 31 321 0 246 -33 411 -131 650 -54 135 -71 164 -172 300 -199 268
-402 439 -684 576 -44 21 -103 43 -133 50 l-54 12 0 154 0 153 28 -6 c15 -3
63 -17 107 -31z m-1987 -16 c6 -7 12 -30 14 -52 3 -38 5 -40 38 -43 72 -5 80
-10 80 -47 0 -41 -5 -44 -70 -52 l-50 -6 0 -53 0 -54 -44 0 -45 0 -3 53 -3 52
-40 3 c-53 5 -67 18 -63 61 3 36 3 36 56 39 l52 3 0 48 c0 26 3 51 7 54 11 12
60 8 71 -6z m3020 5 c7 -5 15 -31 19 -59 l6 -51 45 1 c42 2 47 -1 56 -26 15
-41 -2 -61 -55 -65 -51 -4 -59 -13 -59 -69 l0 -43 -39 0 -40 0 -3 53 -3 52
-43 6 c-48 6 -63 21 -60 59 3 22 8 25 49 28 51 3 59 14 59 78 0 17 3 34 7 37
9 9 45 8 61 -1z m-1518 -166 c0 -35 3 -71 6 -80 5 -14 -7 -16 -97 -16 l-104 0
0 80 0 80 98 0 97 0 0 -64z m155 -21 l0 -75 -67 0 c-39 0 -68 4 -68 10 0 6 7
10 15 10 9 0 15 9 15 24 0 14 5 28 10 31 6 3 10 19 10 34 0 36 6 41 49 41 l36
0 0 -75z m-147 -306 l3 -76 -32 -7 c-17 -3 -62 -6 -100 -6 l-69 0 0 85 0 86
98 -3 97 -3 3 -76z m142 1 l0 -80 -62 0 -63 0 1 73 c0 39 1 75 2 80 1 4 29 7
62 7 l60 0 0 -80z m477 -140 c53 -32 53 -87 -1 -132 -30 -25 -53 -22 -87 11
-43 43 -40 84 9 115 45 30 40 30 79 6z m-1207 -5 c59 -30 62 -75 9 -120 -38
-31 -50 -31 -88 1 -38 31 -42 83 -11 114 24 24 51 25 90 5z m588 -172 l3 -83
-100 0 -100 0 -3 85 -3 86 100 -3 100 -3 3 -82z m142 1 l0 -85 -52 3 -53 3 4
70 c2 39 5 72 7 74 3 3 52 15 87 20 4 0 7 -37 7 -85z m888 -196 c52 -26 112
-91 142 -153 20 -42 21 -46 5 -79 -24 -50 -105 -122 -153 -137 -35 -10 -48 -9
-87 5 -77 30 -79 34 -71 166 14 232 37 261 164 198z m-2035 6 c26 -9 51 -23
56 -33 5 -9 12 -82 16 -163 l7 -148 -43 -20 c-60 -27 -95 -25 -156 10 -65 37
-113 112 -113 176 0 53 42 112 113 159 61 40 60 40 120 19z m1627 -60 l105 -6
-9 -98 -9 -99 -581 2 c-319 1 -654 -2 -742 -6 l-161 -8 -5 103 c-3 57 -4 105
-3 108 5 8 1285 12 1405 4z m-347 -376 c-12 -13 -44 -57 -72 -99 -90 -138
-213 -304 -226 -307 -7 -2 -39 34 -71 79 -91 125 -222 312 -234 332 -10 16 7
17 306 17 l317 0 -20 -22z m-478 -448 c27 -47 66 -112 87 -146 l38 -60 0
-1065 c1 -1126 8 -1457 35 -1508 17 -35 35 -33 62 7 16 25 18 69 26 487 4 253
6 831 4 1285 l-4 825 31 45 c18 25 58 87 89 138 32 51 77 119 100 151 23 32
47 66 52 75 7 12 9 -452 8 -1401 -2 -1357 -3 -1421 -21 -1483 -11 -36 -36
-123 -56 -195 -20 -71 -61 -209 -91 -305 -30 -96 -66 -213 -80 -260 -15 -47
-35 -121 -47 -165 -11 -44 -28 -111 -37 -150 -18 -69 -23 -70 -36 -10 -13 63
-78 296 -120 430 -24 77 -69 223 -100 325 -31 102 -72 237 -92 300 l-37 115 1
1305 c1 718 4 1358 8 1423 l7 117 63 -97 c34 -54 84 -136 110 -183z m-800 136
c39 -107 61 -132 133 -146 87 -17 92 -20 103 -47 13 -35 -3 -51 -59 -58 -110
-16 -119 -20 -150 -88 -17 -34 -38 -84 -47 -111 -16 -44 -19 -47 -31 -32 -7
10 -22 50 -34 89 -26 86 -59 122 -121 131 -101 16 -130 37 -109 76 10 18 39
29 120 45 19 4 43 11 52 17 18 8 58 77 58 97 0 24 43 122 50 114 4 -4 20 -44
35 -87z m2035 3 c29 -96 65 -134 150 -157 64 -17 65 -18 65 -52 0 -33 -2 -35
-50 -48 -87 -23 -105 -34 -130 -77 -14 -23 -25 -47 -25 -53 0 -6 -10 -37 -21
-68 -24 -64 -28 -62 -60 35 -31 93 -85 144 -166 160 -67 13 -86 31 -76 69 4
16 17 23 62 32 104 20 115 29 166 135 25 52 50 95 54 95 5 0 19 -32 31 -71z
m-1802 -691 c7 -7 12 -24 12 -39 0 -14 3 -40 6 -57 6 -31 7 -31 78 -34 l71 -3
0 -55 0 -55 -70 -5 -70 -5 -9 -82 c-9 -82 -9 -83 -36 -83 -39 0 -50 19 -57 99
l-6 71 -78 0 -79 0 0 60 0 60 74 0 74 0 7 63 c4 34 9 65 12 70 7 11 58 8 71
-5z m1557 -20 c2 -13 6 -43 7 -68 l3 -45 73 -3 72 -3 0 -54 0 -55 -70 0 -69 0
-6 -37 c-19 -115 -20 -118 -42 -121 -25 -4 -37 15 -47 73 -13 77 -11 75 -82
75 -71 0 -70 -1 -77 73 l-5 47 74 0 74 0 0 63 c0 35 3 67 7 70 3 4 23 7 44 7
32 0 40 -4 44 -22z m813 -1440 l-5 -863 -86 -83 -85 -84 -4 824 -3 823 52 60
c29 32 69 88 89 122 20 35 39 63 42 63 2 0 2 -388 0 -862z m-3112 652 l44 -55
3 -823 c2 -453 0 -825 -3 -826 -3 -2 -44 39 -92 92 l-88 95 -2 506 c-4 717 -2
1091 6 1145 l7 47 41 -63 c22 -35 60 -88 84 -118z m289 -282 c16 -14 40 -35
53 -45 22 -18 23 -23 25 -213 1 -107 1 -478 0 -825 l-3 -630 -86 83 -87 83 -1
792 c0 436 3 805 7 821 l8 30 27 -35 c15 -18 40 -46 57 -61z m2497 -729 l-7
-794 -82 -82 -81 -83 -4 813 -4 812 35 30 c20 17 58 51 86 77 35 32 52 43 57
34 4 -7 4 -370 0 -807z m-2211 525 c23 -19 61 -45 82 -56 l40 -20 -6 -352 c-4
-193 -7 -559 -7 -813 0 -302 -3 -463 -10 -463 -5 0 -11 17 -11 38 -2 30 -3 32
-6 10 -4 -27 -23 -40 -23 -17 0 8 -6 7 -17 -2 -11 -10 -14 -10 -9 -1 4 6 3 12
-3 12 -25 0 -19 -22 9 -31 17 -6 29 -14 26 -16 -8 -9 14 -44 23 -38 8 5 25
-24 18 -31 -2 -2 -22 17 -46 41 -24 25 -58 54 -76 65 -32 20 -32 21 -39 118
-3 53 -9 360 -12 682 -5 571 1 910 16 910 5 0 27 -16 51 -36z m1887 -793 c-1
-456 -6 -827 -11 -824 -4 2 -7 19 -6 36 2 18 1 61 -1 97 l-3 65 -7 -73 c-5
-41 -4 -87 0 -102 6 -22 4 -32 -12 -46 -15 -14 -21 -15 -27 -5 -5 7 -12 13
-17 13 -23 2 -44 11 -44 19 0 12 3 11 36 -5 36 -19 44 -13 43 32 -1 20 -3 29
-6 20 -3 -13 -15 -18 -39 -18 -34 0 -34 0 -35 48 -1 26 -5 61 -9 77 l-8 30 -2
-30 c-1 -16 -2 -51 0 -77 1 -27 -2 -48 -8 -48 -17 0 -22 206 -22 865 l0 652
83 51 c45 28 86 51 90 52 5 0 7 -373 5 -829z m-340 587 c-1 -49 -3 -59 -5 -30
l-4 43 -47 -7 c-57 -8 -60 -10 -65 -54 -3 -30 -4 -28 -5 13 -2 39 1 47 16 47
10 0 38 13 62 29 25 16 46 30 48 30 1 1 1 -32 0 -71z m-1228 32 c19 -17 29
-30 23 -30 -7 0 -15 5 -18 10 -3 6 -10 10 -15 10 -25 0 -30 -82 -32 -494 l-3
-431 -5 345 c-6 383 -3 620 8 620 4 -1 23 -14 42 -30z m1120 -415 c1 -154 -3
-274 -9 -295 -10 -32 -10 -30 -6 20 3 30 5 165 5 299 0 134 2 242 5 240 2 -3
5 -122 5 -264z m-1118 168 l1 -38 4 38 c6 53 33 51 33 -3 0 -38 -2 -40 -30
-40 -28 0 -30 2 -30 40 0 51 19 53 22 3z m45 -120 c-3 -10 -5 -4 -5 12 0 17 2
24 5 18 2 -7 2 -21 0 -30z m30 0 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2
-21 0 -30z m-30 -130 c-2 -21 -4 -4 -4 37 0 41 2 58 4 38 2 -21 2 -55 0 -75z
m31 -30 c-1 -111 -2 -124 -7 -67 -6 72 -3 204 5 204 2 0 3 -62 2 -137z m1019
-255 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m140 -205 c-2 -38
-3 -7 -3 67 0 74 1 105 3 68 2 -38 2 -98 0 -135z m-150 155 c-3 -8 -6 -5 -6 6
-1 11 2 17 5 13 3 -3 4 -12 1 -19z m-20 -110 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m-1110 -110 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m1458 -430 c3 -58 3 -58 21 -51 8 3 13 11 10 18 -4 13 13 25 36 25
8 0 -30 -54 -74 -104 -4 -6 -8 30 -8 79 0 88 11 113 15 33z m-321 -373 c-4 -8
-8 -15 -10 -15 -2 0 -4 7 -4 15 0 8 4 15 10 15 5 0 7 -7 4 -15z"/>
            </g>
        </svg>
    );
}

export default Crown;